import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { PropertyListingPrice } from '../../shop/components/PropertyListingPrice';
import { SocialShareWidget } from './SocialShareWidget.tsx';
import { WishlistWidget } from './WishlistWidget.tsx';
import { useLocationChange } from '@hooks';
import { useQuickView } from '@providers';
import { useTranslation } from 'react-i18next';

export const QuickViewModal = () => {
  const { t } = useTranslation();

  const { quickViewModalProperty: property, hideQuickViewModal } =
    useQuickView();

  const detailsUrl = property ? `/properties/${property.id}` : '#';
  const title = property ? `${property.subCategory}, ${property.area}` : '';
  const mainThumb =
    property?.mainImages?.[0]?.thumbUrl || property?.mainImages?.[0]?.url || '';

  useLocationChange(hideQuickViewModal);

  return (
    <Modal
      show={!!property}
      onHide={hideQuickViewModal}
      className='ltn__modal-area'
      size='lg'
    >
      <Modal.Header>
        <button
          type='button'
          className='close'
          aria-label='Close'
          onClick={hideQuickViewModal}
        >
          <span aria-hidden='true'>&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {property && (
          <div className='ltn__quick-view-modal-inner'>
            <div className='modal-product-item'>
              <div className='row mb-4'>
                <div className='col-lg-6 col-12 mb-4 mb-lg-0'>
                  <div className='modal-product-img'>
                    <img
                      src={mainThumb}
                      alt={`Photo of ${property.category} property, ${property.area}`}
                    />
                  </div>
                </div>
                <div className='col-lg-6 col-12'>
                  <div className='modal-product-info'>
                    <h3>
                      <Link to={detailsUrl}>{title}</Link>
                    </h3>
                    <PropertyListingPrice {...property} />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='modal-product-info'>
                    {/* Brief description */}
                    {(property.advertisement || property.description) && (
                      <div className='modal-product-brief'>
                        <p>{property.advertisement || property.description}</p>
                      </div>
                    )}

                    <WishlistWidget property={property} />

                    <hr />
                    <SocialShareWidget property={property} />

                    <label className='float-end mb-0'>
                      <Link
                        to={detailsUrl}
                        className='text-decoration'
                        onClick={hideQuickViewModal}
                      >
                        <small>{t('quickViewModal.viewDetails')}</small>
                      </Link>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
